export interface ILanguage {
    code: string;
    name: string;
    flag: string;
    invalid?: boolean;
    isFullyFilled?: any;
}
